//节流防抖

export default (Vue) => {
  Vue.directive("throttle", {
    bind: function (el, binding) {
      const fn = binding.value;
      const eventName = binding.arg;
      let time = null;
      const immediate = binding.modifiers.immediate; //首次是否立即执行
      const instance = vnode.componentInstance;
      if (instance) {
        //组件
        instance.$on(eventName, throttle(fn, time | 1000, immediate));
      } else {
        //普通dom
        el.addEventListener(eventName, debounce);
      }
    },
  });
  Vue.directive("debounce", {
    bind: function (el, binding, vnode) {
      const fn = binding.value;
      const eventName = binding.arg || "click";
      const args = Object.keys(binding.modifiers).sort((a) => {
        if (isNaN(a)) {
          return -1;
        } else {
          return 1;
        }
      });
      const time = isNaN(args[args.length - 1]) ? 1000 : args[args.length - 1];
      console.log(time);
      const immediate = args.indexOf("immediate") != -1; //首次是否立即执行
      const instance = vnode.componentInstance; //组件实例
      if (instance) {
        //组件
        instance.$on(eventName, debounce(fn, time, immediate));
      } else {
        //普通dom
        el.addEventListener(eventName, debounce(fn, time, immediate));
      }
    },
  });
};

//节流
function throttle(fn, time, immediate) {
  let timer = null;
  return function () {
    if (immediate) {
      if (!timer) {
        fn.apply(this, arguments);
        timer = setTimeout(() => {
          timer = null;
          clearTimeout(timer);
        }, time || 1000);
      }
    } else {
      if (!timer) {
        timer = setTimeout(() => {
          fn.apply(this, arguments);
          timer = null;
          clearTimeout(timer);
        }, time || 1000);
      }
    }
  };
}
//防抖
function debounce(fn, time, immediate) {
  let timer = null;
  return function () {
    if (immediate) {
      if (timer) {
        clearTimeout(timer);
      } else {
        fn.apply(this, arguments);
      }
      timer = setTimeout(() => {
        timer = null;
      }, time);
    } else {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        fn.apply(this, arguments);
        timer = null;
      }, time);
    }
  };
}
